import {
  FETCH_FOOTPRINTS,
  SHOW_FOOTPRINTS_SEARCH,
  HIDE_FOOTPRINTS_SEARCH,
  HIDE_FOOTPRINTS,
  SHOW_FOOTPRINTS,
  CHANGE_FORM,
  UPDATE_FOOTPRINTS,
  FETCH_SUGGESTIONS,
  CREATE_FOOTPRINTS
} from './constants'

const initialState = {
  isFetching: false,
  name: '',
  lastname: '',
  phone: '',
  email: '',
  pk: null,
  actions: [],
  active: false,
  error: false,
  searchActive: false,
  id: null,
  isUpdating: false,
  suggestions: [],
  message: '',
  form: {
    name: '',
    lastname: '',
    phone: '',
    email: ''
  }
}

export default function footprintsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FOOTPRINTS.REQUEST: {
      return {
        ...state,
        isFetching: true,
        message: ''
      }
    }

    case FETCH_FOOTPRINTS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        active: true,
        name: action.footprints.first_name,
        lastname: action.footprints.last_name,
        email: action.footprints.email,
        phone: action.footprints.phone,
        actions: action.footprints.actions,
        pk: action.footprints.PK,
        id: action.footprints.id,
        error: false,
        searchActive: false,
        fetched: true,
        suggestions: [],
        form: {
          name: action.footprints.first_name,
          lastname: action.footprints.last_name,
          email: action.footprints.email,
          phone: action.footprints.phone
        }
      }
    }

    case FETCH_FOOTPRINTS.FAILURE: {
      return {
        ...state,
        isFetching: false,
        error: action.error
      }
    }

    case SHOW_FOOTPRINTS_SEARCH: {
      return {
        ...state,
        searchActive: true
      }
    }

    case HIDE_FOOTPRINTS_SEARCH: {
      return {
        ...state,
        searchActive: false
      }
    }

    case HIDE_FOOTPRINTS: {
      return {
        ...state,
        active: false,
        message: ''
      }
    }

    case SHOW_FOOTPRINTS: {
      return {
        ...state,
        active: true,
        error: false
      }
    }

    case CHANGE_FORM: {
      return {
        ...state,
        form: { ...state.form, ...action.data },
        message: ''
      }
    }

    case UPDATE_FOOTPRINTS.REQUEST: {
      return {
        ...state,
        isUpdating: true,
        message: ''
      }
    }

    case UPDATE_FOOTPRINTS.SUCCESS: {
      return {
        ...state,
        ...action.data,
        isUpdating: false,
        message: 'Details updated.'
      }
    }

    case FETCH_SUGGESTIONS.SUCCESS: {
      return {
        ...state,
        suggestions: action.suggestions
      }
    }

    case CREATE_FOOTPRINTS.FAILURE: {
      return {
        ...state
      }
    }

    case CREATE_FOOTPRINTS.REQUEST: {
      return {
        ...state
      }
    }

    case CREATE_FOOTPRINTS.SUCCESS: {
      return {
        ...state
      }
    }

    default: {
      return state
    }
  }
}
